import { ELogoutActionTypes, TLogoutFailed } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const logoutFailure: () => TLogoutFailed = actionGenerator<ELogoutActionTypes.Failed>(ELogoutActionTypes.Failed);
